// @core/api/endpoints/user/update_user.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateUserRequest,
  UserResponse,
} from '../../../types/user';

const BASE_PATH = '/user';

/**
 * Update user data
 * Updates user profile information including name, preferences, and other metadata. Publishes a user.updated event on success for downstream service synchronization.
 */
export async function UpdateUser(
  id: string,
  data: UpdateUserRequest,
  options?: RequestOptions
): Promise<UserResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.put<UserResponse>(requestPath, data, requestOptions);
}
